<div class="page-load-wrapper">
    <div class="ss-spinner page"></div>
</div>